// Money formatting helpers — amounts are stored as integers in smallest currency unit
// (paise for INR, cents for USD).
export function formatMoney(amount, currency) {
  if (amount === null || amount === undefined) return "—";
  const major = Number(amount) / 100;
  if (currency === "INR") {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      maximumFractionDigits: Number.isInteger(major) ? 0 : 2,
    }).format(major);
  }
  if (currency === "USD") {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    }).format(major);
  }
  // Fallback
  return `${major} ${currency || ""}`.trim();
}

export function currencySymbol(currency) {
  if (currency === "INR") return "₹";
  if (currency === "USD") return "$";
  return currency || "";
}

export function smallestUnitToMajor(amount) {
  return Number(amount || 0) / 100;
}

export function majorToSmallestUnit(major) {
  const n = Number(major);
  if (Number.isNaN(n)) return 0;
  return Math.round(n * 100);
}

// Pretty interval label
export function intervalLabel(interval) {
  if (interval === "monthly") return "/ month";
  if (interval === "yearly") return "/ year";
  return "";
}
